import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Joyride from "react-joyride";
import { locale } from '../../utils/joyride';

const DetailVocabulary = ({id, nextRun, study, passed, content}) => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    setRun(!!(study && !study.vocabularyPassed && nextRun === 'vocabulary'));
  }, [nextRun]);

  useEffect(() => {
    window.listenAudio();
  }, []);

  return (
    <div className="row justify-content-center">
      <Joyride 
        run={run}
        locale={locale} 
        scrollOffset={80} 
        steps={[
          {
            target: '.vocabulary-content',
            content: 'В Лексике будут самые распространенные слова. Можно прослушать произношения',
            disableBeacon: true,
          },
          {
            target: '.btn-vocabulary',
            content: 'Теперь пройдите тест',
            disableBeacon: true,
          },
        ]}
      />
      <div className="col-lg-9">
        <div className="mb-4 overflow-auto vocabulary-content" dangerouslySetInnerHTML={{__html: content}} />
        <Link replace to={`/my-lessons/${id}/vocabulary/test`} className={`btn btn-vocabulary btn-${passed ? 'success' : 'primary'}`}>
          Пройти тест{passed ? ' заново' : ' '}
        </Link>
      </div>
    </div>
  );
};

export default DetailVocabulary;
